import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { aiSettingsAPI } from '../api';

// Cache compartida entre todos los selectores de la pagina: una consulta por
// proveedor, no una por desplegable.
const cache = {};
const enCurso = {};

export const cargarModelos = async (proveedor) => {
  if (cache[proveedor]) return cache[proveedor];
  if (!enCurso[proveedor]) {
    enCurso[proveedor] = aiSettingsAPI
      .getModelosDisponibles(proveedor)
      .then(({ data }) => {
        cache[proveedor] = data;
        return data;
      })
      .catch(() => {
        const vacio = { modelos: [], via: 'no disponible', aviso: '' };
        cache[proveedor] = vacio;
        return vacio;
      })
      .finally(() => { delete enCurso[proveedor]; });
  }
  return enCurso[proveedor];
};

export const olvidarModelos = () => {
  Object.keys(cache).forEach((k) => delete cache[k]);
};

/**
 * Desplegable con los modelos reales del proveedor, preguntados a su API con la
 * clave propia. Si el proveedor no contesta, cae a una lista orientativa; y si
 * el modelo guardado no está en la lista, se añade para no perderlo.
 */
const SelectorModeloIA = ({ proveedor, value, onChange, disabled, testId, placeholder }) => {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    let vivo = true;
    if (!proveedor || proveedor === 'auto') { setDatos(null); return undefined; }
    setCargando(true);
    cargarModelos(proveedor).then((d) => {
      if (vivo) { setDatos(d); setCargando(false); }
    });
    return () => { vivo = false; };
  }, [proveedor]);

  if (!proveedor || proveedor === 'auto') {
    return (
      <select
        data-testid={testId}
        disabled
        className="w-full h-10 rounded-md border border-gray-200 bg-gray-50 px-3 text-sm text-gray-400"
      >
        <option>{placeholder || 'lo elige el sistema'}</option>
      </select>
    );
  }

  const lista = datos?.modelos || [];
  const conGuardado = value && !lista.includes(value) ? [value, ...lista] : lista;

  return (
    <div className="space-y-1">
      <div className="relative">
        <select
          data-testid={testId}
          value={value || ''}
          disabled={disabled || cargando}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-10 rounded-md border border-gray-300 bg-white px-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-gray-50"
        >
          <option value="">Recomendado por el sistema</option>
          {conGuardado.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
        {cargando && (
          <RefreshCw className="w-4 h-4 animate-spin text-gray-400 absolute right-2.5 top-3 pointer-events-none" />
        )}
      </div>
      {datos?.aviso && (
        <p className="text-[11px] text-amber-700 leading-tight">{datos.aviso}</p>
      )}
    </div>
  );
};

export default SelectorModeloIA;
